import { Icon } from "@qw/ui";
import type { ReactNode } from "react";

import { EmptyStateWithActions } from "./empty-state-with-actions";

export interface MissingChatSessionProps {
  className?: string;
  description?: ReactNode;
  icon?: ReactNode;
  title?: string;
}

export const MissingChatSession = ({
  className = "items-center justify-center p-8",
  description = "There isn't an Alby chat session to show yet.",
  icon,
  title = "No chat history yet",
}: MissingChatSessionProps = {}) => {
  return (
    <EmptyStateWithActions
      className={className}
      icon={
        icon ?? (
          <div className="size-12 rounded-full bg-primary/10 flex items-center justify-center text-3xl text-primary">
            <Icon icon="forum" />
          </div>
        )
      }
      title={title}
      description={description}
    />
  );
};
